<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="7">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-alert variant="danger" :show="hasError">{{ error }} </b-alert>
              <b-card-body>
                <form @submit.prevent="onSubmit">
                  <h1>Login</h1>
                  <p class="text-muted">Sign In to your account</p>
                  <b-input-group class="mb-3">
                    <b-input-group-prepend><b-input-group-text><i class="icon-user"></i></b-input-group-text></b-input-group-prepend>
                    <b-form-input type="email" class="form-control" v-model="email" placeholder="Email Address" :required="true"/>
                  </b-input-group>
                  <b-input-group class="mb-4">
                    <b-input-group-prepend><b-input-group-text><i class="icon-lock"></i></b-input-group-text></b-input-group-prepend>
                    <b-form-input type="password" v-model="password" class="form-control" placeholder="Password" :required="true"/>
                  </b-input-group>
                  <b-row>
                    <b-col cols="7">
                      <button type="button" class="btn btn-md btn-primary" v-if="formLoading" disabled>
                        <i class="fa fa-spinner fa-spin"></i> Authenticating...
                      </button>
                      <button v-else type="submit" class="btn btn-md btn-primary px-4">Login</button>
                    </b-col>
                    <b-col cols="5" class="text-right">
                      <!-- <b-button variant="link" class="px-0">Forgot password?</b-button> -->
                    </b-col>
                  </b-row>
                </form>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
  name: 'Login',
  data() {
    return {
      email : "",
      password : "",
    }
  },
  computed: {
    ...mapState([
      'loading',
      'formLoading',
      'error'
    ]),
    ...mapGetters([
      'hasError'
    ])
  },
  methods : {
    ...mapActions([
      'login'
    ]),
    async onSubmit(e) {
      if (this.password.length !== "" && this.email.length !== "") {
        const result = await this.login({
          email: this.email,
          password: this.password
        });

        if(result) {
          if (localStorage.getItem('jwt') != null){
            this.$emit('loggedIn')
            if(this.$route.params.nextUrl != null){
              this.$router.push(this.$route.params.nextUrl)
            } else { 
              this.$router.push('/dashboard')
            }
          }
        }
      }
    }
  }
}
</script>
